import {Component, EventEmitter, Output, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {AlertController, DateTime, NavParams, Select, ViewController} from 'ionic-angular';

/**
 * Modal for the scheduling of content
 * @class ScheduleModalComponent
 */
@Component({
  selector: 'advtech-schedule-modal',
  templateUrl: './schedule-modal.component.html',
})
export class ScheduleModalComponent {

  @Output()
  static onSchedule: EventEmitter<any> = new EventEmitter();

  @Output()
  static onScheduleAndExit: EventEmitter<any> = new EventEmitter();

  @Output()
  static onUnschedule: EventEmitter<any> = new EventEmitter();
  /**
   * The date value
   * @type {string}
   */
  date: string;

  /**
   * The time value
   * @type {string}
   */
  time: string;

  /**
   * The timezone value
   * @type {string}
   */
  timezone: string;

  /**
   * Preferred timezones that should show up first
   * @type {object[]}
   */
  preferredTimezones: object[];

  /**
   * Other timezones to show up below the preferred timezones
   * @type {object[]}
   */
  otherTimezones: object[];

  /**
   * The form group
   * @type {FormGroup}
   */
  formGroup: FormGroup;

  /**
   * Reference to the date component
   */
  @ViewChild('dateComponent')
  dateComponent: DateTime;

  /**
   * Reference to the time component
   */
  @ViewChild('timeComponent')
  timeComponent: DateTime;

  /**
   * Reference to the timezone component
   */
  @ViewChild('timezoneComponent')
  timezoneComponent: Select;

  /**
   * Tells the template if the content is scheduled
   *
   * @type {boolean}
   */
  isScheduled: boolean = false;

  constructor(private viewCtrl: ViewController, private navParams: NavParams, private alertController: AlertController) {
    this.date = this.navParams.get('date').replace(/\//g, '-');
    this.time = this.navParams.get('time');
    this.timezone = this.navParams.get('timezone');
    this.formGroup = this.navParams.get('formGroup');
    this.preferredTimezones = this.navParams.get('preferredTimezones');
    this.otherTimezones = this.navParams.get('otherTimezones');

    if (this.date && this.time) {
      this.isScheduled = true;
    }
  }

  /**
   * Schedules the content
   * @param {boolean} unlock unlocks the content if true
   * @returns {void}
   */
  hSchedule(): void {
    ScheduleModalComponent.onSchedule.emit();
    this.viewCtrl.dismiss();
  }

  /**
   * Schedules the content
   * @returns {void}
   */
  hScheduleAndUnlock(): void {
    ScheduleModalComponent.onScheduleAndExit.emit();
    this.viewCtrl.dismiss();
  }

  /**
   * Unschedules the content
   * @returns {Promise<any>}
   */
  hUnschedule(): Promise<any> {
    return this.alertController.create({
      title: 'Unschedule?',
      message: `Are you sure you want to cancel publishing at ${this.date} ${this.time}?`,
      buttons: [
        {
          text: 'No',
          role: 'cancel',
        },
        {
          text: 'Yes',
          handler: () => this.hUnscheduleConfirm(),
        },
      ],
    }).present();
  }

  /**
   * Dismisses the modal
   * @returns {Promise<any>}
   */
  dismiss(): Promise<any> {
    return this.viewCtrl.dismiss({status: 'cancel'});
  }

  /**
   * Returns true if the date and time fields are empty - disables the scheduling buttons
   * @returns {boolean}
   */
  isDateTimeEmpty(): boolean {
    return !(this.date && this.time);
  }

  protected hUnscheduleConfirm() {
    this.formGroup.patchValue({
      date: null,
      time: null,
    });
    this.date = null;
    this.time = null;
    this.formGroup.updateValueAndValidity();
    ScheduleModalComponent.onUnschedule.emit();
    this.viewCtrl.dismiss();
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/schedule-modal/schedule-modal.component.ts